import React from 'react';
import classNames from 'classnames';
import DropdownList from './DropdownList';
import styles from './styles.module.scss';
import icArrow from 'assets/svg/ic_arrow_fill.svg';
import CheckboxWithLabel from '../../../Components/CheckboxWithLabel';
import { options } from './config';

const EventMultipleSelect = ({
  onSelect,
  className,
  values
}) => {
  const ref = React.useRef(null);
  const [collapsed, setCollapsed] = React.useState(true);
  const isCheckAll = React.useMemo(() => {
    return options.every(e => values.some(v => v === e.id));
  }, [values]);
  const displayText = React.useMemo(() => {
    if (isCheckAll || values.length === 0) {
      return 'All Events';
    }

    const listSelected = options.filter(e => values.includes(e.id));

    if (listSelected.length === 1) {
      return listSelected[0].label;
    }

    return `${listSelected.length} events selected`;
  }, [isCheckAll, values]);

  const toggleDropdown = () => {
    setCollapsed(!collapsed);
  };

  const closeDropdown = () => {
    setCollapsed(true);
  };

  const onItemChange = (item, checked) => {
    if (checked) {
      onSelect(values.concat(item.id));
    } else {
      onSelect(values.filter(id => id !== item.id));
    }
  };

  React.useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        closeDropdown();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classNames(styles.wrapper, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container,
    onClick: e => {
      e.stopPropagation();
      toggleDropdown();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.spanLabel
  }, displayText)), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.icon, !collapsed && styles.collapse)
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.img,
    src: icArrow
  }))), /*#__PURE__*/React.createElement(DropdownList, {
    className: classNames(styles.dropdown, collapsed && styles.hide)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.group
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.hr
  }, /*#__PURE__*/React.createElement(CheckboxWithLabel, {
    label: "All Events",
    onChange: value => {
      if (value) {
        onSelect(options.map(e => e.id));
      } else {
        onSelect([]);
      }
    },
    check: isCheckAll
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.group
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.hr
  }, options.map(item => /*#__PURE__*/React.createElement(CheckboxWithLabel, {
    key: item.id,
    disabled: isCheckAll,
    onChange: value => {
      onItemChange(item, value);
    },
    label: item.label,
    check: values.includes(item.id)
  }))))));
};

export default EventMultipleSelect;